import $ from "jquery";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./assets/klass.VuwArrayChild";

vuwer
/**
 * VuwArrayField (extends VuwField)
 * @options
 * - {Boolean} required
 * - {Number} ltd
 * - {Object} dataParams
 */
.appendKlass("VuwArrayField", {
	inpType: "array",
	childKlass: "VuwArrayChild",
	requiredText: "*",
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwArrayField").parent._initialize.call(this, opt) ) {
			// [バリデーションの登録]
			// 必須
			this.addValidation("required", function(val) {
				return !this.required || !!val.length;
			}, "必須項目です");
			
			// 数の制限
			this.addValidation("ltd", function(val) {
				return !u_.isNumber(this.ltd) || val.length <= this.ltd;
			}, this.ltd ? String(this.ltd) + "つ以内にして下さい" : "");
			
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		this.$btnAddChild = $self.find(".btn-addChild");
		!this.$btnAddChild.length && (this.$btnAddChild = false);
		
		$self.on("click", ".btn-addChild", function(e) {
			var
				vuw = $.data(e.delegateTarget, "vuw"),
				$btn = $(this);
			
			e.preventDefault();
			if( $btn.hasClass("is-disable") ) {
				return false;
			}
			
			vuw.addChild();
		});
		return this;
	},
	
	getDefaultChildProp: function getDefaultChildProp() {
		return {
			vuwType: "arrayChild",
			requiredText: this.requiredText,
			dataParams: this.dataParams,
			selector: (function() {
				return $("<var/>").insertBefore(this.$btnAddChild.$parent);
			}).bind(this)
		};
	},
	
	addChild: function addChild(callback) {
		var children, idx, childProp, df = $.Deferred();
		
		if( this.$self.hasClass("is-limit") || !this.$btnAddChild ) {
			csl.log.grey("addChild ... return");
			return df.reject();
		}
		
		!this.$btnAddChild.$parent && ( this.$btnAddChild.$parent = this.$btnAddChild.parent() );
		children = this.getChildren();
		idx = !!children.length ? parseInt( children.get(-1).name.replace(/^child_/, "") ) + 1 : 0;
		idx = u_.zeroPadding(idx, 2);
		
		childProp = this.getDefaultChildProp();
		childProp.paramKey = this.paramKey + "_" + idx;
		u_.isFunction(callback) && (childProp.onReadyLast = callback);
		
		this.add("child_" + idx, childProp, function() {
			this.getReady().then( df.resolve.bind(df, this), df.reject.bind(df) );
		});
		
		if(this.ltd && children.length + 1 === this.ltd) {
			this.$self.addClass("is-limit");
		}
		
		return df.promise();
	},
	
	// [override]
	validate: function validate() {
		var err_cnt = 0;
		this.getChildren().forEach(function(vuw) {
			if(vuw.getVal() !== false && !vuw.validate() ) {
				err_cnt++;
			}
		});
		
		if(!err_cnt) {
			Klass("VuwArrayField").parent.validate.call(this) || err_cnt++;
		}
		
		return !err_cnt;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		var promiseList = [];
		// 初期化
		this.removeChildren();
		
		if(this.$self) {
			this.$self.removeClass("is-limit");
			
			if(Array.isArray(value) && value.length && this.$btnAddChild) {
				value.forEach(function(val) {
					u_.isObject(val) && promiseList.push( this.addChild(function() {
						return this.setVal(val, antiTriggerChange);
					}) );
				}, this);
			} else
			if(!antiTriggerChange) {
				// エラー表示のリフレッシュおよび拡張性を持たせるため、changeイベントをトリガーする
				this.$self.trigger("change", [true]);
			}
		}
		
		return $.when.apply($, promiseList);
	},
	
	getVal: function getVal() {
		var value = [];
		this.getChildren().forEach(function(vuw) {
			var v = vuw.getVal();
			u_.isObject(v) && value.push(v);
		}, this);
		return value;
	},
	
	getCopiedElement: function getCopiedElement() {
		var $clone = Klass("VuwArrayField").parent.getCopiedElement.call(this);
		!!$clone && $clone.children(".btn").remove();
		return $clone;
	},
	
	_getCopiedInp: function _getCopiedInp() {
		var clones = [];
		this.getChildren().forEach(function(vuw) {
			var $clone = vuw.getCopiedElement();
			!!$clone && clones.push($clone);
		});
		return clones;
	},
	
	_renderField: function _renderField() {
		var elms = [];
		elms.push(
			$("<div/>").addClass("btns").append(
				$("<a/>").addClass("btn-addChild").attr("href", "./").append("<span/>")
			)
		);
		
		return $.fn.append.apply(
			$("<div/>").addClass("vuw-field field-array").attr({
				"id": ["field", this.idStr].join("_"),
				"data-name": this.paramKey
			}),
			elms
		);
	}
}, "VuwField");
